import { useLocation } from 'react-router';
import { getUrlParams } from 'utils/urlParams';

export const useCampaignIdFromUrlParams = () => {
  const { search } = useLocation();
  const { campaignId } = getUrlParams(search);
  // getUrlParams returns an object of key-value pairs that are all strings.
  // the backend requires the campaignId to be a number
  // so we convert it here before returning it to the component
  return Number(campaignId);
};
